import { gql } from "@apollo/client";

export const CREATE_FAMILYDETAILS = gql`
  mutation createFamilyDetails($input: createFamilyDetailsInput) {
    createFamilyDetails(input: $input) {
      userId
    }
  }
`;



export const UPDATE_FAMILY_DETAILS = gql`
  mutation updateFamilyDetails($input: updateFamilyDetailsInput) {
    updateFamilyDetails(input: $input)
  }
`;

export const DELETE_FAMILY_DETAILS = gql`
  mutation deleteFamilyDetails($Id: Int!) {
    deleteFamilyDetails(Id: $Id)
  }
`;
